import React from 'react'
import PropTypes from 'prop-types'
import HomePage from '../home'
import PageWithPagination from '../../components/PageWithPagination'
import TableWithPagination from '../../components/TableWithPagination'
import MyTableHeaderSort from '../../components/MyTableHeaderSort'
import DeleteIcon from '@material-ui/icons/Delete'
import { actions } from '../../redux/modules/referralCodes'
import DeleteDialog from '../../components/DeleteDialog'
import ErrorMessage from '../../components/errormessage'
import CheckIcon from '@material-ui/icons/Check'
import ClearIcon from '@material-ui/icons/Clear'
import { SearchIcon } from '../../Icons/svg'

class ReferralCodesList extends PageWithPagination {
  constructor(props) {
    super(props)
    this.state = {
      list: [],
      totalCount: 0,
      isLoading: true,
      errorMessage: '',
      searchField: 'code'
    }
    // Bind listener of browser history change
    this.addHistoryListener(this.getList)
  }

  async componentDidMount () {
    // Initialize params from query string or use default and fetch data
    const { location } = this.props
    const params = Object.assign({}, location.query || {})

    if (!params.orderBy) {
      params.orderBy = 'index'
    }

    if (!params.order) {
      params.order = 'ASC'
    }

    this.setQueryParamsToState(params, this.getList)
  }

  /**
   * Fetches data
   */
  getList = async () => {
    const { page, perPage, order, orderBy, searchField, searchKeyword } = this.state
    const { success, data, error } = await actions.getList({
      page,
      perPage,
      order,
      orderBy,
      searchField,
      searchKeyword
    })

    if (error) {
      return this.setState({ errorMessage: error })
    }

    if (success && data) {
      this.setState({
        list: data.items || [],
        totalCount: data.total || 0,
        isLoading: false
      })
    }

    this.setState({
      isLoading: false
    })
  }

  getTexts = () => {
    return {
      tableTitle: 'Referral Codes'
    }
  }

  edit = (e, obj) => {
    e.preventDefault()
    this.props.router.push({
      pathname: '/referral-code-edit',
      state: { obj: obj }
    })
  }

  /**
  * Listens delete btn
  */
  handleItemDelete = (e, item) => {
    if (!item || !item._id) {
      return
    }

    const deleteDialogParams = {
      open: true,
      title: `Are you sure you want to delete "${item.code || ''}" ?`,
      handleConfirm: async () => {
        try {
          deleteDialogParams.handleClose()
          const delRes = await actions.deleteById(item._id)
          if (delRes && delRes.success) {
            await this.getList()
          }
        } catch (e) {
          console.error(e.message)
        }
      },
      handleClose: () => {
        this.setState({ deleteDialogParams: false })
      },
      handleCancel: () => {
        deleteDialogParams.handleClose()
      }
    }

    this.setState(state => {
      return {
        ...state,
        deleteDialogParams
      }
    })
  }

   /**
   * Changes history when searching
   * and data is fetched
   */
  handleСhangeSearch = e => {
    e.preventDefault()
    let searchField = 'code'
    let searchKeyword = e.target.value
    searchKeyword = searchKeyword.replace(/[-+*.?|^$/()[\]{}\\]/g, '\\$&')

    this.setState(state => {
      return {
        ...state,
        searchField,
        searchKeyword,
        page: 1
      }
    }, async () => {
      this.debouncedUpdateHistory()
    })
  }

  makeToolBar = () => {
    return (
      <div className="device-tools">
        <div className="search-icon">
          <SearchIcon />
        </div>
        <input
            className="search-input"
            onChange={this.handleСhangeSearch}
            placeholder='Search Codes'
            tabIndex="-1"
            value={this.state.searchKeyword || ''}
          />
          <div>
            <button className={'btn green mr-2'} onClick={this.edit}>+</button>
          </div>
      </div>
    )
  }

  makeHead = () => {
    return (
      <div className={'table-head'}>
        <div style={{ width: '25%', paddingLeft: '15px' }}>
          <MyTableHeaderSort
            label="Code"
          />
        </div>
        <div style={{ width: '25%', paddingLeft: '15px' }}>
          <MyTableHeaderSort
            label="Limit"
          />
        </div>
        <div style={{ width: '25%', paddingLeft: '15px' }}>
          <MyTableHeaderSort
            label="Usage Counter"
          />
        </div>
        <div style={{ width: '15%', paddingLeft: '15px' }}>
          <MyTableHeaderSort
            label="Enabled"
          />
        </div>

        <div style={{ width: '15%' }}>
          <MyTableHeaderSort label="Actions" />
        </div>
      </div>
    )
  }

  makeRow = item => {
    return (
      <div className={'table-row'}>
        <div style={{ width: '25%', paddingLeft: '15px' }}>
          {item.code}
        </div>
        <div style={{ width: '25%', paddingLeft: '15px' }}>
          {item.isUnlimited ? 'Unlimited' : item.limit }
        </div>
        <div style={{ width: '25%', paddingLeft: '15px' }}>
          {item.usageCounter ? item.usageCounter : 0 }
        </div>
        <div style={{ width: '15%', paddingLeft: '15px' }}>
          {item.isEnabled ? <CheckIcon/> : <ClearIcon/>}
        </div>
        <div style={{ width: '10%' }}>
          <button
            type="button"
            className="btn"
            onClick={e => this.edit(e, item)}
          >
            Edit
          </button>
        </div>
        <div style={{ width: '5%'}}>
          <button
            type="button"
            className="btn"
            onClick={e => this.handleItemDelete(e, item)}
          >
            <DeleteIcon />
          </button>
        </div>
      </div>
    )
  }

  render () {
    const {
      order,
      orderBy,
      totalCount,
      list,
      page,
      perPage,
      deleteDialogParams,
      errorMessage,
      isLoading
    } = this.state
    return (
      <HomePage router={this.props.router} addClassName="h-100">
        <div className="device-table-container">
          <ErrorMessage text={errorMessage} />
          {!isLoading && (
            <TableWithPagination
              tableName={this.getTexts().tableTitle}
              tableToolBar={this.makeToolBar}
              tableHead={this.makeHead}
              tableRow={this.makeRow}
              hasIndex={true}
              hasPagination={true}
              page={(page - 1)}
              rowsPerPage={perPage}
              totalCount={totalCount}
              order={order}
              orderBy={orderBy}
              data={list}
              handleChangePage={this.handleChangePage}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
            />
          )}
        </div>
        {deleteDialogParams && <DeleteDialog {...deleteDialogParams} />}
      </HomePage>
    )
  }
}

ReferralCodesList.propTypes = {
  location: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired
}

export default ReferralCodesList
